const routes = {
  root: '/program/details',
}

export default routes
